import React from 'react';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import { DynamicMediaItem } from '@uncinc/react-drupal-core';

import {
  ImmutableEntity,
} from '@uncinc/react-drupal-core/types';
import { BlockCTA } from '../../../types/uncinc_profile/blocks';
import { ButtonWrapper } from '../../../components';

import './style.scss';

export interface CtaBlockProps {
  entity: ImmutableEntity<BlockCTA>;
}

const CTABlock: React.FC<CtaBlockProps> = ({
  entity,
}) => {
  const ctaBlock = entity.toJS();
  const title = ctaBlock.info[0]?.value;
  const body = ctaBlock.body[0]?.processed;
  const contentImage = ctaBlock.field_media?.[0];
  const backgroundImage = ctaBlock.field_use_as_background?.[0]?.value === true;
  const linkTitle = ctaBlock.field_link[0].title;
  const linkUri =
    ctaBlock.field_link[0].alias ||
    ctaBlock.field_link[0].uri;

  const secondaryLinkTitle = ctaBlock.field_link_secondary?.[0]?.title;
  const secondaryLinkUri =
    ctaBlock.field_link_secondary?.[0]?.alias ||
    ctaBlock.field_link_secondary?.[0]?.uri;

  const colClasses = (!backgroundImage && contentImage) ?
    'col-12 col-md-8 col-lg-7' :
    'col-12 col-md-10  col-lg-8 ';

  return (
    <Container>
      <div className="CTABlock">
        <div className="row">

          <div className={colClasses}>
            <div className="CTABlock__wrapper">
              {(backgroundImage && contentImage) && (
                <div className="CTABlock__overlay">
                  <DynamicMediaItem
                    media={contentImage}
                    imageAspectRatio="3_2"
                    className="CTABlock__backgroundMedia"
                  />
                </div>
              )}

              <div className="CTABlock__content">
                <h2 className="CTABlock__title">{title}</h2>
                {body && (
                  <WysiwygField className="CTABlock__body" html={body} />
                )}
              </div>


              <div className="CTABlock__links">
                <ButtonWrapper
                  href={linkUri}
                >
                  {linkTitle}
                </ButtonWrapper>

                {secondaryLinkUri && (
                  <ButtonWrapper
                    secondary
                    href={secondaryLinkUri}
                  >
                    {secondaryLinkTitle}
                  </ButtonWrapper>
                )}
              </div>
            </div>
          </div>

          {(!backgroundImage && contentImage) && (
            <div className="col-12 col-md-4 col-lg-3">
              <DynamicMediaItem
                media={contentImage}
                imageAspectRatio="1_1"
                className="CTABlock__contentMedia"
              />
            </div>
          )}
        </div>
      </div>

    </Container>
  );
};

export default CTABlock;
